import { render, staticRenderFns } from "./JobSetupForm.vue?vue&type=template&id=045838b6&"
import script from "./JobSetupForm.vue?vue&type=script&lang=js&"
export * from "./JobSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports